export const strings = {
  ar: {
    nav: {
      tiktok: "تيك توك", guides: "الأدلة", faq: "الأسئلة", about: "عن الموقع",
      login: "دخول بحساب Google", logout: "تسجيل الخروج", theme: "تبديل المظهر",
    },
    hero: {
      tag: "أداة تيك توك فقط · مجانية",
      l1: "تحميل فيديو تيك توك",
      l2: "بدون علامة مائية",
      sub: "حمّل فيديوهات تيك توك بدون علامة مائية بجودة HD، واستخرج الصوت MP3. الصق الرابط وحمّل مباشرة من الجوال أو الكمبيوتر بدون تثبيت أي برنامج.",
      cta: "حمّل الآن مجاناً",
      sec: "كيف يعمل؟",
    },
    dl: {
      kicker: "الصق · حمّل · احفظ",
      title1: "حمّل مقطع",
      title2: "تيك توك الآن",
      single: "رابط واحد", bulk: "روابط متعددة",
      pastePh: "الصق رابط فيديو تيك توك هنا…",
      catch: "حمّل", catching: "جاري التحليل…",
      caught: "تم العثور على الفيديو ✓",
      catchAll: "تحليل الكل", catchingAll: "جاري تحليل الكل…",
      bulkHint: "حتى 10 روابط تيك توك، رابط واحد في كل سطر",
      bulkNeed: "الصق رابط تيك توك واحداً على الأقل",
      bulkNone: "لم نستطع تحليل أي رابط — تأكد أن الروابط عامة ومن تيك توك",
      bulkCaught: "تم تحليل {ok} من أصل {n} روابط",
      detected: "رابط تيك توك صحيح ✓",
      supportedHint: "ندعم روابط فيديوهات تيك توك العامة فقط",
      pasteFirst: "الصق رابط فيديو تيك توك أولاً",
      quality: "الجودة:", hd: "HD", sd: "SD",
      dlVideo: "تحميل الفيديو", dlAudio: "تحميل الصوت MP3",
      secs: "ث", views: "مشاهدة",
      progV: "جاري تحميل الفيديو…", progA: "جاري استخراج الصوت…", progShort: "جاري التحميل…",
      doneV: "تم تحميل الفيديو", doneA: "تم تحميل الصوت",
      dlFail: "فشل التحميل — حاول مرة أخرى",
      share: "شارك المقطع:",
      fetchFail: "تعذر تحليل الرابط — تحقق منه وحاول مجدداً",
      serverFail: "تعذر الاتصال بالخادم — حاول بعد قليل",
      loginFail: "فشل تسجيل الدخول، حاول مجدداً",
      logoutOk: "تم تسجيل الخروج",
      welcome: "مرحباً بك!",
      errInvalid: "الرابط غير صالح — انسخ رابط فيديو تيك توك كاملاً",
      errPlatform: "هذه المنصة غير مدعومة — ندعم روابط تيك توك فقط",
      errUnavail: "المحتوى خاص أو غير متاح",
      errNotFound: "الفيديو غير موجود أو حُذف من تيك توك",
      errTimeout: "استغرق التحليل وقتاً طويلاً — حاول مجدداً",
      errFailed: "فشل التحليل — حاول بعد قليل",
      errRate: "طلبات كثيرة جداً — انتظر دقيقة وحاول مجدداً",
      errBlocked: "تيك توك يقيّد الوصول مؤقتاً — حاول بعد قليل",
      errLarge: "الملف أكبر من الحد المسموح",
    },
    trust: {
      title1: "لماذا", title2: "؟",
      cards: [
        { t: "بدون علامة مائية", d: "احفظ الفيديو نظيفاً عندما يوفر المصدر نسخة بلا علامة." },
        { t: "يعمل على كل الأجهزة", d: "آيفون، أندرويد، ويندوز وماك — من المتصفح مباشرة." },
        { t: "فيديو وصوت", d: "اختر MP4 بجودة HD أو استخرج الصوت MP3 بنقرة واحدة." },
        { t: "بلا تثبيت", d: "لا تطبيقات ولا إضافات — الصق الرابط وحمّل فوراً." },
      ],
    },
    howit: {
      title1: "كيف تحمّل من", title2: "؟",
      steps: [
        { t: "انسخ رابط تيك توك", d: "افتح الفيديو في تيك توك، اضغط مشاركة ثم نسخ الرابط." },
        { t: "الصق الرابط هنا", d: "ضع الرابط في صندوق التحميل وسنتعرف عليه تلقائياً." },
        { t: "اختر الصيغة", d: "حمّل الفيديو MP4 بجودة HD أو احفظ الصوت MP3." },
      ],
    },
    marquee: ["بدون علامة مائية", "جودة HD أصلية", "تيك توك فقط", "تحميل غير محدود", "بدون تثبيت", "استخراج MP3"],
    seo: {
      h2a: "أداة تحميل تيك توك الأسرع والأبسط",
      paras: [
        "SS Downloader هو موقع متخصص في تحميل فيديوهات تيك توك العامة فقط، بدون علامة مائية عندما تكون متاحة من المصدر. لا تحتاج إلى تثبيت تطبيق أو إنشاء حساب؛ كل ما تحتاجه هو رابط الفيديو العام.",
        "الصق الرابط في الأعلى، انتظر ثواني قليلة، ثم اختر تحميل الفيديو بجودة HD أو حفظ الصوت بصيغة MP3. إذا كان الفيديو خاصاً أو محذوفاً، سنوضح لك السبب برسالة صادقة بدلاً من إظهار زر لا يعمل.",
      ],
      howT: "التحميل في ثلاث خطوات",
      steps: [
        { t: "1. انسخ رابط الفيديو", d: "من تطبيق تيك توك اضغط مشاركة ثم نسخ الرابط." },
        { t: "2. الصق الرابط في الأداة", d: "ضع الرابط في صندوق التحميل بالأعلى واضغط حمّل." },
        { t: "3. اختر MP4 أو MP3", d: "احفظ الفيديو بدون علامة مائية أو استخرج الصوت فقط." },
      ],
      featT: "ماذا تحصل مع SS Downloader؟",
      feats: ["فيديو تيك توك MP4 بدون علامة مائية", "جودة HD عند توفرها", "استخراج صوت MP3", "يعمل على الجوال والكمبيوتر", "لا يحتاج تسجيل أو تثبيت", "رسائل خطأ واضحة إذا كان الفيديو خاصاً"],
      devices: [
        { t: "التحميل على الآيفون", b: "انسخ الرابط من تيك توك، افتح هذه الصفحة في Safari، الصق الرابط وحمّل. سيُحفظ الملف في تطبيق الملفات، ويمكنك نقله إلى الصور من مشاركة ← حفظ فيديو." },
        { t: "التحميل على أندرويد", b: "انسخ الرابط، الصقه في المتصفح، ثم اضغط تحميل. سيظهر الفيديو في مجلد التنزيلات أو معرض الصور حسب إعدادات هاتفك." },
        { t: "التحميل على الكمبيوتر", b: "انسخ رابط الفيديو من موقع تيك توك والصقه هنا. سيُحفظ الملف بجودته الأصلية في مجلد التنزيلات، جاهزاً للمشاهدة أو الأرشفة." },
      ],
      faqT: "أسئلة شائعة عن تحميل تيك توك",
      faqs: [
        { q: "هل التحميل مجاني؟", a: "نعم، تحميل فيديوهات تيك توك العامة مجاني ولا يحتاج إلى اشتراك." },
        { q: "هل يمكن التحميل بدون علامة مائية؟", a: "نعم، نوفر نسخة بدون علامة مائية عندما تكون متاحة من المصدر." },
        { q: "هل أستطيع استخراج الصوت MP3؟", a: "نعم، بعد تحليل الرابط اضغط زر تحميل الصوت MP3." },
        { q: "هل يعمل الموقع على الآيفون والأندرويد؟", a: "نعم، يعمل من المتصفح على iOS وأندرويد والكمبيوتر بدون تثبيت تطبيق." },
        { q: "هل تدعمون منصات أخرى؟", a: "لا، SS Downloader متخصص الآن في تيك توك فقط لتقديم تجربة أسرع وأكثر استقراراً." },
      ],
    },
    foot: {
      desc: "أداة مجانية وسريعة لتحميل فيديوهات تيك توك العامة MP4 وMP3 من المتصفح مباشرة.",
      quickCol: "روابط سريعة", companyCol: "الموقع", legalCol: "قانوني",
      about: "عن الموقع", contact: "اتصل بنا", guides: "الأدلة", faq: "الأسئلة الشائعة", sitemap: "خريطة الموقع",
      privacy: "سياسة الخصوصية", terms: "شروط الاستخدام", cookies: "ملفات الارتباط", dmca: "DMCA",
      legal: "حمّل فقط المحتوى العام الذي تملكه أو لديك إذن لحفظه. لا تتجاوز الأداة الحسابات الخاصة أو أي حماية تقنية، ونحترم حقوق صنّاع المحتوى وشروط تيك توك.",
      rate: "قيّم تجربتك:", thanks: "شكراً لتقييمك!", avg: "التقييم", ratings: "تقييم",
      made: "مصمم لتحميل تيك توك بسرعة ونظافة", language: "اللغة",
    },
    ad: {
      label: "إعلان",
      wait: "سيبدأ التحميل تلقائياً بعد انتهاء العدّاد…",
      ready: "يبدأ التحميل الآن…",
    },
  },
  en: {
    nav: {
      tiktok: "TikTok", guides: "Guides", faq: "FAQ", about: "About",
      login: "Sign in with Google", logout: "Sign out", theme: "Toggle theme",
    },
    hero: {
      tag: "TikTok only · Free",
      l1: "Download TikTok Videos",
      l2: "Without Watermark",
      sub: "Download public TikTok videos without watermark in HD, or extract MP3 audio. Paste the link and download on mobile or desktop — nothing to install.",
      cta: "Download now — free",
      sec: "How it works",
    },
    dl: {
      kicker: "Paste · Download · Save",
      title1: "Download your",
      title2: "TikTok video",
      single: "Single link", bulk: "Bulk links",
      pastePh: "Paste a TikTok video link here…",
      catch: "Download", catching: "Analyzing…",
      caught: "Video found ✓",
      catchAll: "Analyze all", catchingAll: "Analyzing all…",
      bulkHint: "Up to 10 TikTok links, one per line",
      bulkNeed: "Paste at least one TikTok link",
      bulkNone: "No links could be analyzed — make sure they are public TikTok videos",
      bulkCaught: "Analyzed {ok} of {n} links",
      detected: "Valid TikTok link ✓",
      supportedHint: "We support public TikTok video links only",
      pasteFirst: "Paste a TikTok video link first",
      quality: "Quality:", hd: "HD", sd: "SD",
      dlVideo: "Download video", dlAudio: "Download MP3 audio",
      secs: "s", views: "views",
      progV: "Downloading video…", progA: "Extracting audio…", progShort: "Downloading…",
      doneV: "Video downloaded", doneA: "Audio downloaded",
      dlFail: "Download failed — try again",
      share: "Share video:",
      fetchFail: "Could not analyze the link — check it and try again",
      serverFail: "Server connection failed — try again shortly",
      loginFail: "Sign-in failed, try again",
      logoutOk: "Signed out",
      welcome: "Welcome!",
      errInvalid: "Invalid URL — paste a complete TikTok video link",
      errPlatform: "Unsupported platform — we support TikTok links only",
      errUnavail: "Content is private or unavailable",
      errNotFound: "Video not found or deleted from TikTok",
      errTimeout: "Analysis timed out — try again",
      errFailed: "Analysis failed — try again shortly",
      errRate: "Too many requests — wait a minute and try again",
      errBlocked: "TikTok is temporarily restricting access — try later",
      errLarge: "File exceeds the allowed size",
    },
    trust: {
      title1: "Why", title2: "?",
      cards: [
        { t: "No watermark", d: "Save a clean copy whenever the source provides one." },
        { t: "Works everywhere", d: "iPhone, Android, Windows and Mac — straight from the browser." },
        { t: "Video and audio", d: "Choose HD MP4 or extract MP3 audio with one tap." },
        { t: "Nothing to install", d: "No apps or extensions — paste the link and download." },
      ],
    },
    howit: {
      title1: "How to download from", title2: "?",
      steps: [
        { t: "Copy the TikTok link", d: "Open the video in TikTok, tap Share, then Copy link." },
        { t: "Paste it here", d: "Drop the link into the download box and we detect it automatically." },
        { t: "Choose a format", d: "Download MP4 in HD quality or save the audio as MP3." },
      ],
    },
    marquee: ["No watermark", "Original HD quality", "TikTok only", "Unlimited downloads", "Nothing to install", "MP3 audio extraction"],
    seo: {
      h2a: "The fast, simple TikTok downloader",
      paras: [
        "SS Downloader is focused on one job: downloading public TikTok videos without a watermark when the source allows it. No app, no account and no software installation — just the public video link.",
        "Paste the link above, wait a few seconds, then choose HD MP4 video or MP3 audio. If a video is private or deleted, we tell you honestly instead of showing a button that does not work.",
      ],
      howT: "Download in three steps",
      steps: [
        { t: "1. Copy the video link", d: "In TikTok, tap Share then Copy link on the public video." },
        { t: "2. Paste it into the tool", d: "Place the link in the box above and press Download." },
        { t: "3. Choose MP4 or MP3", d: "Save the video without watermark or extract audio only." },
      ],
      featT: "What you get with SS Downloader",
      feats: ["TikTok MP4 without watermark", "HD quality when available", "MP3 audio extraction", "Works on mobile and desktop", "No registration or installation", "Clear errors for private or deleted videos"],
      devices: [
        { t: "Downloading on iPhone", b: "Copy the link from TikTok, open this page in Safari, paste and download. The file is saved to Files, and you can move it to Photos via Share → Save Video." },
        { t: "Downloading on Android", b: "Copy the link, paste it in your browser and tap Download. The video appears in Downloads or your gallery depending on your phone settings." },
        { t: "Downloading on a computer", b: "Copy the video link from TikTok's website and paste it here. The file downloads in its original quality to your Downloads folder, ready to watch or archive." },
      ],
      faqT: "TikTok download FAQ",
      faqs: [
        { q: "Is it free?", a: "Yes, downloading public TikTok videos is free and needs no subscription." },
        { q: "Can I download without a watermark?", a: "Yes, we provide a no-watermark copy whenever the source makes one available." },
        { q: "Can I extract MP3 audio?", a: "Yes. After analyzing the link, press the Download MP3 audio button." },
        { q: "Does it work on iPhone and Android?", a: "Yes, it works in the browser on iOS, Android and desktop with nothing to install." },
        { q: "Do you support other platforms?", a: "No. SS Downloader is now focused on TikTok only to keep the service faster and more reliable." },
      ],
    },
    foot: {
      desc: "A free, fast tool for downloading public TikTok videos as MP4 or MP3, right from your browser.",
      quickCol: "Quick links", companyCol: "Site", legalCol: "Legal",
      about: "About", contact: "Contact", guides: "Guides", faq: "FAQ", sitemap: "Sitemap",
      privacy: "Privacy Policy", terms: "Terms of Service", cookies: "Cookies", dmca: "DMCA",
      legal: "Only download public content you own or have permission to save. The tool never bypasses private accounts, login walls or technical protection, and we respect creators' rights and TikTok's terms.",
      rate: "Rate your experience:", thanks: "Thanks for rating!", avg: "Rating", ratings: "ratings",
      made: "Built for fast, clean TikTok downloads", language: "Language",
    },
    ad: {
      label: "Advertisement",
      wait: "Your download starts automatically when the countdown ends…",
      ready: "Starting your download…",
    },
  },
};
